import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../apiSetup/apiCall';

export const chargerLogsData = createAsyncThunk('chargerlogs/fetchLogsData', async ({selectedChargerLink,startDate,endDate,selectedChargerQueryLink}) => {
  try {
    let url = `/${selectedChargerLink}`;
    if(startDate && endDate)
      url += `${startDate}/${endDate}/`;
    const response = await api.get(url);
    const queryId = response.data?.data?.query_id;
    const queryUrl = selectedChargerQueryLink.replace('query_id',queryId);
    let i = 0;
    for(i=0; i<1; i++){
      try{
        const logsResponse = await api.get(queryUrl);
        if (logsResponse?.data?.code === "SU0x1109")
          i = -1;
        else
          return logsResponse?.data;
      }
      catch(error){
        throw error
      }
    }
  } catch (error) {
    console.error('Error fetching logs data:', error);
    throw error;
  }
});

const ChargerLogsSlice = createSlice({
  name: 'chargerLogs',
  initialState: {
    data: [],
    isLoading: false,
    error: null,
    currentChargerApi: false,
    currentChargerQueryApi: false,
    queryId: false
  },
  reducers: {
    setCurrentChargerApi: (state,action) =>{
      state.currentChargerApi = action.payload;
    },
    setCurrentChargerQueryApi: (state,action) =>{
      state.currentChargerQueryApi = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(chargerLogsData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(chargerLogsData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(chargerLogsData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});


export const { setCurrentChargerApi, setCurrentChargerQueryApi } = ChargerLogsSlice.actions;
export default ChargerLogsSlice.reducer;
